import { render, staticRenderFns } from "./YesNoQuestion.vue?vue&type=template&id=bbf08b42"
import script from "./YesNoQuestion.vue?vue&type=script&lang=js"
export * from "./YesNoQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports